import { render, staticRenderFns } from "./WebHostingEmailAlias.vue?vue&type=template&id=eeb62722&scoped=true&"
import script from "./WebHostingEmailAlias.vue?vue&type=script&lang=js&"
export * from "./WebHostingEmailAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb62722",
  null
  
)

export default component.exports